import api from './api';

const enc = (s) => encodeURIComponent(s);
const base = (maClb) => `/api/clb/${enc(maClb)}/ket-noi`;

/**
 * Quản lý kết nối website riêng của CLB (khóa API + webhook).
 * Khóa bản rõ và webhookSecret CHỈ có trong phản hồi của create / xoayKhoa / xoayWebhookSecret — hiển thị một lần.
 */
const clbKetNoiService = {
  /** { scopes: string[], events: string[] } */
  meta: async (maClb) => (await api.get(`${base(maClb)}/meta`)).data.data,

  list: async (maClb) => (await api.get(base(maClb))).data.data || [],

  /** → { client, apiKey, webhookSecret } */
  create: async (maClb, body) => (await api.post(base(maClb), body)).data.data,

  update: async (maClb, id, body) => (await api.put(`${base(maClb)}/${id}`, body)).data.data,

  xoayKhoa: async (maClb, id) => (await api.post(`${base(maClb)}/${id}/xoay-khoa`)).data.data,

  xoayWebhookSecret: async (maClb, id) => (await api.post(`${base(maClb)}/${id}/xoay-webhook-secret`)).data.data,

  thuHoi: async (maClb, id) => { await api.delete(`${base(maClb)}/${id}`); },

  /** Page<{id, deliveryId, event, status, attempts, lastStatusCode, lastError, createdAt, nextRetryAt, deliveredAt}> */
  webhookLogs: async (maClb, id, page = 0, size = 20) =>
    (await api.get(`${base(maClb)}/${id}/webhook-logs`, { params: { page, size } })).data.data,

  guiLai: async (maClb, id, deliveryId) =>
    (await api.post(`${base(maClb)}/${id}/webhook-logs/${deliveryId}/gui-lai`)).data.data,

  /** Gửi sự kiện "ping" đồng bộ, trả DeliveryView ngay */
  kiemTraWebhook: async (maClb, id) => (await api.post(`${base(maClb)}/${id}/kiem-tra-webhook`)).data.data,
};

export default clbKetNoiService;
